/** @jsxImportSource @emotion/react */

import React, { useState, forwardRef, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { configState } from "../lib/State";
import { Box, Checkbox } from "@mui/material";
import CenterSelect from "./CenterSelect";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { TextareaAutosize } from "@material-ui/core";

// 등록하기 팝업
export default function ReportFcEdit({ login, onClose, seq }) {
  const token = localStorage.getItem("token");
  const [tcid, setTcid] = useState("");
  const [state, setState] = useState("");
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState("");
  const [mname, setMname] = useState("");
  const [memo, setMemo] = useState("");

  useEffect(() => {
    const getData = async () => {
      const result = await axios.post(
        `${process.env.REACT_APP_API}/gympass_admin/fc_report_one`,
        {
          token: token,
          level: login.level,
          mcd: login.mcd,
          seq,
        }
      );
      if (!result?.data?.success) return;
      setRows(result.data.rows);
      setTitle(result.data.title);
      setTcid(result.data.tcid);
      setMname(result.data.mname);
      setMemo(result.data.memo);
    };
    getData();
  }, []);

  const onSubmit = async () => {
    let result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/fc_report_edit`,
      {
        token: token,
        level: login.level,
        mcd: login.mcd,
        rows,
        title,
        cid: tcid,
        seq,
        mname,
        memo,
      }
    );
    if (result.data.success === 0) {
      Swal.fire("Error", result.data.msg);
      return;
    } else {
      onClose();
    }
  };

  const onDelete = async () => {
    let result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/fc_report_delete`,
      {
        token: token,
        level: login.level,
        mcd: login.mcd,
        seq,
      }
    );
    if (result.data.success === 0) {
      Swal.fire("Error", result.data.msg);
      return;
    } else {
      onClose();
    }
  };

  const changeData = (target, value, index) => {
    let copyArray = [...rows];
    if (index !== undefined) {
      const copy = copyArray[index];
      copy[target] = value ? "Y" : "N";
    } else {
      for (let i in copyArray) {
        const copy = copyArray[i];
        copy[target] = value ? "Y" : "N";
      }
    }
    setRows(copyArray);
  };

  return (
    <Box sx={{ padding: 2 }}>
      {/* 가맹점 */}
      <CenterSelect login={login} tcidParent={tcid} setTcidParent={setTcid} />
      {/* 제목 */}
      <Box>
        <TextField
          sx={{ width: "100%", mt: 1 }}
          label="제목"
          size="small"
          onChange={(e) => setTitle(e.target.value)}
          autoComplete="off"
          value={title}
        />
      </Box>
      <Box>
        <TextField
          sx={{ width: "16%", mt: 1 }}
          label="작성자"
          size="small"
          onChange={(e) => setMname(e.target.value)}
          autoComplete="on"
          value={mname}
        />
      </Box>

      {/* 리스트 */}
      <Box
        sx={{
          fontSize: "1rem",
          padding: 2,
          mt: 3,
        }}
      >
        <Box
          sx={{
            padding: "1rem 0.3rem 0",
            display: "grid",
            gridTemplateColumns: "repeat(12, 1fr)",
            gap: 1,
            textAlign: "center",
            fontSize: "1.1rem",
            fontWeight: "bold",
            opacity: 0.8,
            borderBottom: "1px solid lightgray",
            borderTop: "1px solid lightgray",
          }}
        >
          <Box>번호</Box>
          <Box sx={{ gridColumn: "2/12" }}>문항</Box>
          <Box>이행</Box>
        </Box>
        {rows.map((data, index) => (
          <Box
            key={index}
            sx={{
              padding: "0.5rem 0.3rem",
              backgroundColor: index % 2 !== 0 ? "rgba(0,0,0,0.15)" : "",
              borderRadius: "7px",
              display: "grid",
              gridTemplateColumns: "repeat(12, 1fr)",
              gap: 1,
              alignItems: "center",
            }}
          >
            <Box sx={{ opacity: 0.6, textAlign: "center" }}>{index + 1}</Box>
            <Box sx={{ flex: 1, gridColumn: "2/12" }}>{data.question}</Box>
            <Checkbox
              onChange={(e) => changeData("center", e.target.checked, index)}
              checked={data.center === "Y"}
            />
          </Box>
        ))}
      </Box>
      {/* 비고란 */}
      <Box>
        <TextareaAutosize
          minRows={3}
          maxRows={10}
          style={{
            width: "100%",
            resize: "none",
            borderColor: "rgba(0, 0, 0, 0.23)",
            borderRadius: "4px",
            marginTop: "1rem",
            fontSize: "1rem",
            padding: "8.5px 14px",
          }}
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
          placeholder="특이사항을 적어주세요."
        />
      </Box>
      {/* 버튼 */}
      <Box
        sx={{
          mt: 5,
          textAlign: "center",
          display: "flex",
          gap: 1,
          justifyContent: "center",
        }}
      >
        <Button variant="contained" onClick={onSubmit}>
          등록완료
        </Button>
        <Button variant="contained" color="error" onClick={onDelete}>
          삭제
        </Button>
        <Button variant="contained" color="warning" onClick={onClose}>
          닫기
        </Button>
      </Box>
    </Box>
  );
}
